export default "__VITE_ASSET__DHEmRskt__"